export default __webpack_public_path__ + "e55eb505ca5c5fa02ae299379ac7145d.png";